var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "template-preview" },
    [
      _c("div", { staticClass: "template-preview__title" }, [
        _c("input", {
          staticClass: "cursor-pointer",
          attrs: { type: "checkbox" },
          domProps: { checked: _vm.checked },
          on: {
            change: function ($event) {
              return _vm.handleTemplateSelect(_vm.template.instance_id)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "d-flex cursor-pointer align-items-center",
            on: { click: _vm.handleLayersVisibility },
          },
          [
            _c("b-icon", {
              staticClass: "mr-2",
              class: { closed: !_vm.layersVisible, opened: _vm.layersVisible },
              attrs: { icon: "triangle-fill" },
            }),
            _vm._v(
              "\n      " + _vm._s(_vm.trimName(_vm.template.name)) + "\n    "
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("b-collapse", { attrs: { visible: _vm.layersVisible } }, [
        _vm.isLayersPreparing
          ? _c("span", {
              staticClass: "spinner-border spinner-border-sm mx-4 my-2",
              attrs: { role: "status", "aria-hidden": "true" },
            })
          : _c(
              "div",
              { staticClass: "template-preview__layers-list" },
              _vm._l(_vm.filteredLayers, function (layer) {
                return _c(
                  "div",
                  { key: layer.id, staticClass: "template-preview__layer" },
                  [
                    _c("input", {
                      staticClass: "cursor-pointer",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: _vm.selectedLayers.find(
                          (_layer) => _layer.id === layer.id
                        ),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleLayerSelect(layer)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "template-preview__layer-preview" },
                      [
                        layer.properties.subType === _vm.LAYER_SUBTYPE.TEXT
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "template-preview__layer-preview--text",
                              },
                              [
                                _c("b-icon", {
                                  staticClass: "d-block",
                                  attrs: { icon: "textarea-t" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        layer.properties.subType === _vm.LAYER_SUBTYPE.IMAGE
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "template-preview__layer-preview--image",
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: layer.properties.src,
                                    alt: "layer-preview",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.trimName(layer.name)) +
                        "\n      "
                    ),
                  ]
                )
              }),
              0
            ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }